module.exports = __webpack_public_path__ + "static/media/logo_purple.bf2ccba2.png";